module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "hello"
  }, [_c('c-head'), _vm._v(" "), _vm._m(0)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "view-content"
  }, [_c('div', {
    staticClass: "home-img"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/img/campus-home.png")
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/.10.3.0@vue-loader/lib/template-compiler.js?id=data-v-466754df!./~/.10.3.0@vue-loader/lib/selector.js?type=template&index=0!./src/views/home.vue
// module id = 33
// module chunks = 1